import { useTitanApp } from "@/hooks/useTitanApp";

export const usePatientPreConsultData = () => {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const {
    preConsultationTemplate,
    preConsultAddtoSummary,
    preConsultationTranscription,
    consultationData,
    selectedPatientConsultation,
    preConsultData
  } = patientState || {};

  const getSeverityColor = (answer: string | string[]) => {
    if (typeof answer === "string") {
      if (answer.includes("7-8") || answer.includes("9-10"))
        return "text-red-600 bg-red-50";
      if (answer.includes("5-6")) return "text-yellow-600 bg-yellow-50";
      if (answer.includes("1-2") || answer.includes("3-4"))
        return "text-green-600 bg-green-50";
    }
    return "";
  };

  const getConditionColor = (conditions: string | string[]) => {
    if (
      Array.isArray(conditions) &&
      conditions.length > 0 &&
      !conditions.includes("None of the above")
    ) {
      return "text-orange-600 bg-orange-50";
    }
    return "";
  };

  return {
    darkMode,
    preConsultationTemplate,
    preConsultAddtoSummary,
    consultationData,
    selectedPatientConsultation,
    preConsultData
  };
};
